/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native';

const TermsScreen =
  Platform.OS === 'web' ? require('./terms.web').default : require('./terms.native').default;

export default TermsScreen;
